var theme = window.theme || {}
let data = {}
let counter = 4
var selections = {}
var seatsElem = document.getElementById('selected-seats')
var slotsElem = document.getElementById('colors__btn-container')
var addElem = document.getElementById('color__add-btn')
let i = -1
let slotsHTML = ''
let slots = []

/*////////////////////////////////////////////////////////*/

async function _getCurrentProduct() {
  const product = document.querySelector(`script[id*='ProductJson']`)

  if (product) {
    return JSON.parse(product.innerHTML)
  }

  let url

  url = `https://${window.location.host + window.location.pathname}.json`
  return new Promise(async (resolve, reject) => {
    let response = await fetch(url)

    let { product } = await response.json()
    window.ezfy_product = product

    resolve(product)
  })
}

async function _getCurrentVariant(data) {
  const product = await _getCurrentProduct()
  const variant = await _getVariantID(product, data)
  return variant
}

function _getVariantID(product, currentVariantID) {
  const variant = product.variants.filter((e) => {
    return e.id + '' === currentVariantID
  })
  return variant[0]
}

async function currentVariant(data) {
  return await _getCurrentVariant(data)
}

function resetSlots() {
  const getSlot = document.querySelectorAll(`input[id="input-bundle"]`)
  Array.from(getSlot).forEach((element) => {
    element.remove()
  })
  slots = []
  slots.push(
    {
      id: null,
      color: undefined,
      isFree: false,
      isAdd: false,
      isActive: true,
      borderTop: false,
      isUsed: false,
    },
    {
      id: null,
      color: undefined,
      isFree: false,
      isAdd: false,
      isActive: false,
      borderTop: false,
      isUsed: false,
    },
    {
      id: null,
      color: undefined,
      isFree: false,
      isAdd: false,
      isActive: false,
      borderTop: false,
      isUsed: false,
    },
    {
      id: null,
      color: undefined,
      isFree: true,
      isAdd: false,
      isActive: false,
      borderTop: false,
      isUsed: false,
    },
    {
      id: null,
      color: undefined,
      isFree: false,
      isAdd: true,
      isActive: false,
      borderTop: false,
      isUsed: false,
    }
  )
}

function addSlots() {
  slots[4].isAdd = false
  slots.push(
    {
      id: null,
      color: undefined,
      isFree: true,
      isAdd: false,
      isActive: false,
      borderTop: true,
      isUsed: false,
    },
    {
      id: null,
      color: undefined,
      isFree: false,
      isAdd: false,
      isActive: false,
      borderTop: true,
      isUsed: false,
    },
    {
      id: null,
      color: undefined,
      isFree: false,
      isAdd: false,
      isActive: false,
      borderTop: true,
      isUsed: false,
    },
    {
      id: null,
      color: undefined,
      isFree: false,
      isAdd: false,
      isActive: false,
      borderTop: true,
      isUsed: false,
    },
    {
      id: null,
      color: undefined,
      isFree: false,
      isAdd: false,
      isActive: false,
      borderTop: true,
      isUsed: false,
    }
  )

  updateSlots()
}

function removeSlot(index) {
  const found = (element) => element.isActive
  const findActive = slots.findIndex(found)
  //var input = document.getElementById('input-'+index);
  // const getSlot = document.querySelectorAll(`input[value="${slots[index].id}"]`)
  // getSlot[0].remove()
  // element.remove()
  if (findActive >= 0) {
    //input.parentNode.removeChild(input);
    slots[findActive].isActive = false
    slots[index].isActive = true
  } else {
    slots[index].isActive = true
  }

  slots[index].id = null
  slots[index].isUsed = false
  slots[index].color = undefined

  updateSlots()
  updateProgressBar()
}

function updateProgressBar() {
  var barElem = document.getElementById('progress__bar-line')
  var msgElem = document.getElementById('progress__msg')

  let progress = 0
  let msg = ''
  let checkSpots = slots.filter((slot) => {
    return slot.id
  }).length
  switch (true) {
    case checkSpots == 1:
      progress = 17
      msg = 'You’re 1 pack away from $0.99 shipping in the U.S.'
      break
    case checkSpots == 2:
      progress = 33
      msg = 'Congrats! you got $0.99 shipping in the US.'
      break
    case checkSpots == 3:
      progress = 50
      msg = 'You’re 1 pack away from 1 free pack.'
      break
    case checkSpots == 4:
      progress = 67
      msg = 'Congratulations! Your 4th pack is free!'
      break
    case checkSpots == 5:
      progress = 83
      msg = 'You’re 1 pack away from 1 more free pack.'
      break
    case checkSpots >= 6:
      progress = 100
      msg = 'Congratulations! Your 6th pack is free!'
      break
    default:
      progress = 0
      msg = ''
      break
  }

  barElem.innerHTML = `<span id="progress-bar" class="progress-quantity progress-${progress}"></span>`
  msgElem.innerHTML = msg
}

function updateSlots() {
  slotsHTML = ''
  const items = getItemsWithQuantity(slots)
  var bundleCart = document.getElementById('bundleCart')
  if (items.length > 0) {
    bundleCart.disabled = false
  }
  slots.forEach(function (val, index) {
    let checkActive = val.isActive ? 'active' : ''
    let checkWhite = val.color === '#ffffff' ? 'border: 1px solid black;border-radius:50%;' : ''
    let checkBorder = val.borderTop ? 'border-top: 1px solid #ededed;' : ''
    if (val.isFree) {
      if (!val.id) {
        slotsHTML +=
          `<div class="btn__bundle-container free__pack ` +
          checkActive +
          `" style="display: flex;` +
          checkBorder +
          `">
                  <p>
                      FREE
                  </p>
                  <svg width="25" height="25" viewBox="0 0 25 25" fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12.5" cy="12.5" r="12" fill="white" stroke="#D1D4D3" stroke-dasharray="4 4">
                      </circle>
                      <path d="M12.4992 8.07812L13.868 10.9928L16.9242 11.4457L14.7117 13.7302L15.2367 16.9206L12.4992 15.4042L9.76172 16.9206L10.2867 13.7302L8.07422 11.4457L11.1305 10.9928L12.4992 8.07812Z" fill="#D1D4D3">
                      </path>
                  </svg>
                  <p>
                      PACK!
                  </p>
              </div>
              `
      } else {
        slotsHTML +=
          `<div class="btn__bundle-container" style="display: flex;` +
          checkBorder +
          `">
              <button type="button" class="close__small" onclick="removeSlot(` +
          index +
          `)">
                  <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect y="4.5957" width="6.5" height="1" rx="0.5" transform="rotate(-45 0 4.5957)" fill="black">
                      </rect>
                      <rect x="0.707031" width="6.5" height="1" rx="0.5" transform="rotate(45 0.707031 0)" fill="black">
                      </rect>
                  </svg>
              </button>
              <p>
                  FREE
              </p>
              <div class="btn__color" style="` +
          checkWhite +
          `">
                  <span style="background-color: ` +
          val.color +
          `; width: 100%; height: 100%; display: inline-block; border-radius: 50%;">
          <img class="image_bundle" src="` +
          val.color +
          `">
                  </span>
              </div>
              <p>
                  PACK!
              </p>
          </div>`
      }
    } else if (val.isAdd) {
      slotsHTML += `<button onClick="addSlots()" type="button" class="color__add-btn"><svg width="11" height="11" viewBox="0 0 11 11" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <rect y="5" width="11" height="1" rx="0.5" fill="#D1D4D3"></rect>
                <rect x="6" width="11" height="1" rx="0.5" transform="rotate(90 6 0)" fill="#D1D4D3"></rect>
            </svg>
            <p>ADD PACKS</p>
        </button>`
    } else {
      if (!val.id) {
        slotsHTML +=
          `  <div class="btn__bundle-container ` +
          checkActive +
          `" style="display: flex;` +
          checkBorder +
          `">
            <div class="btn__color">
              <svg width="25" height="25" viewBox="0 0 25 25" fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12.5" cy="12.5" r="12" stroke="#D1D4D3" stroke-dasharray="4 4"/>
                </svg>

          </div>
        </div>`
      } else {
        slotsHTML +=
          `<div class="btn__bundle-container" style="display: flex;` +
          checkBorder +
          `">
            <button type="button" class="close__small" onclick="removeSlot(` +
          index +
          `)">
                <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect y="4.5957" width="6.5" height="1" rx="0.5" transform="rotate(-45 0 4.5957)" fill="black">
                    </rect>
                    <rect x="0.707031" width="6.5" height="1" rx="0.5" transform="rotate(45 0.707031 0)" fill="black">
                    </rect>
                </svg>
            </button>
            <div class="btn__color" style="` +
          checkWhite +
          `">
                <span style="background-color: ` +
          val.color +
          `; width: 100%; height: 100%; display: inline-block; border-radius: 50%;">
          <img class="image_bundle" src="` +
          val.color +
          `">
                </span>
            </div>
        </div>`
      }
    }
  })
  slotsElem.innerHTML = slotsHTML
}

/* Add to bundle */
async function displayCheck(e) {
  const currency = window.Shopify.currency.active
  const res = await currentVariant(e.target.getAttribute('data-variant'))
  if (res !== null || res !== undefined) {
    const imgVariant = e.target.getAttribute('src')
    const price = res.price
    const found = (element) => !element.id && element.isActive
    const foundNext = (element) => !element.id && !element.isActive
    const findIndex = slots.findIndex(found)
    const findNext = slots.findIndex(foundNext)
    let priceHTML = '$' + price + ' ' + currency + '/pack'
    let form = document.getElementById('add-pack-one-cart')

    if (findNext != -1) {
      slots[findNext].isActive = true
    }

    if (findIndex != -1) {
      if (!slots[findIndex].isAdd) {
        slots[findIndex].id = res.id
        slots[findIndex].color =
          e.target.getAttribute('data-color') === undefined
            ? e.target.getAttribute('data-color')
            : imgVariant
        slots[findIndex].isActive = false
        /*var x = document.createElement("INPUT");
        x.setAttribute("type", "hidden");
        x.setAttribute("id", "input-"+findIndex);
        x.setAttribute("name", "id");
      	x.setAttribute("class", "input-form");
        x.setAttribute("key", findIndex);
        x.setAttribute("value", res.id);
        form.prepend(x);*/
      }
    }

    document.getElementById('price-container').innerHTML = priceHTML
    updateSlots()
    updateProgressBar()
  }
}

function getItemsWithQuantity(arr) {
  let arr2 = []
  arr.forEach((x) => {
    if (x['id'] !== null) {
      if (!x['isUsed']) {
        x['isUsed'] = true
        //add item at mini-cart
        // const newItem = document.createElement('input')
        // newItem.type = 'hidden'
        // newItem.name = 'id'
        // newItem.value = x.id
        // newItem.id = 'input-bundle'
        // const attForm = document.getElementsByClassName('bundle__add-cart')
        // const bundleCart = document.getElementById('bundleCart')
        // attForm[0].appendChild(newItem)
        // attForm[0].insertBefore(bundleCart, newItem)
      }
      if (
        arr2.some((val) => {
          return val['id'] == x['id']
        })
      ) {
        arr2.forEach((k) => {
          if (k['id'] === x['id']) {
            k['quantity']++
          }
        })
      } else {
        let a = {}
        a['id'] = x['id']
        a['quantity'] = 1
        arr2.push(a)
      }
    }
  })

  return arr2
}

async function bundleAddToCart() {
  const items = getItemsWithQuantity(slots)
  if (items.length > 0) {
    /*resetSlots();
        updateSlots();
        updateProgressBar();
        const inputs = document.querySelectorAll('.input-form');
        inputs.forEach(input => {
          input.remove();
      	});*/
    await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items: items }),
    })
      .then((response) => {
        //document.getElementById('cart-notification').classList.add('active');
        resetSlots()
        updateSlots()
        updateProgressBar()
        const inputs = document.querySelectorAll('.input-form')
        inputs.forEach((input) => {
          input.remove()
        })
        return response.json()
      })
      .catch((error) => {
        console.error('Error:', error)
      })
  }
}

/* DOM LOADED */
window.addEventListener('DOMContentLoaded', (event) => {
  resetSlots()
  /* SHOW/HIDE ADD TO CART BUTTON */
  //document.getElementById("tab-1").checked = true

  document.querySelectorAll('input[name="tab-effect-3"]').forEach((elem) => {
    /* document.getElementById(elem.value).classList.add('hide');
     if(elem.checked){
       console.log(elem.value);
       document.getElementById(elem.value).classList.remove('hide');
     }*/

    elem.addEventListener('change', function (event) {
      var elems = document.querySelectorAll('input[name="tab-effect-3"]')
      ;[].forEach.call(elems, function (el) {
        document.getElementById(el.value).classList.remove('hide')
      })
      var item = event.target.value
      if (event.target.checked) {
        document.getElementById(item).classList.add('hide')
      }
    })
  })

  /* SLIDER */
  const slider = tns({
    container: '.my-slider',
    loop: true,
    items: 1,
    nav: true,
    autoplay: false,
    speed: 400,
    lazyload: false,
    controls: false,
  })

  /*////////////////////////////////////////////////////////*/

  /* SINGLE PDP */
  var inputs = document.getElementsByClassName('variants-btn'),
    x = inputs.length
  let check = document.querySelector('.variants-btn.active')
  //Variant Radios
  while (x--) {
    if (inputs[x].type === 'radio') {
      inputs[x].setAttribute('data-slide', x)

      if (inputs[x].checked) {
        let currentSlide = inputs[x].getAttribute('data-slide')
        if (slider) slider.goTo(currentSlide)
      }
      inputs[x].addEventListener(
        'change',
        function () {
          document.getElementById('form__label__value').innerHTML = this.value
          currentVariant(this.value)
          let slide = this.getAttribute('data-slide')
          if (slider) slider.goTo(slide)
        },
        0
      )
      inputs[x].addEventListener(
        'click',
        function () {
          document.getElementById('form__label__value').innerHTML = this.value
          currentVariant(this.value)
          let slide = this.getAttribute('data-slide')
          if (slider) slider.goTo(slide)
        },
        0
      )
    }
  }

  /*////////////////////////////////////////////////////////*/

  /* BUNDLE PDP */
  //Cart notification
  var el = document.getElementById('bundleCart')
  el.addEventListener('click', bundleAddToCart, false)

  //Variant Checkboxes
  var radioElems = document.querySelectorAll('input[name="variant_radio"]')
  for (var i = 0; i < radioElems.length; i++) {
    radioElems[i].setAttribute('data-slide', i)
    radioElems[i].addEventListener('click', displayCheck, true)
    radioElems[i].addEventListener(
      'change',
      function () {
        document.getElementById('bundle__label__value').innerHTML = this.value
        let slide = this.getAttribute('data-slide')
        if (slider) slider.goTo(slide)
      },
      0
    )
    radioElems[i].addEventListener(
      'click',
      function () {
        document.getElementById('bundle__label__value').innerHTML = this.value
        let slide = this.getAttribute('data-slide')
        if (slider) slider.goTo(slide)
      },
      0
    )
  }

  //Call color slots
  updateSlots()
})
